import styled from "styled-components";
import { H3, Chip, Description, transition, Icon, Flex } from "@evergis/ui";

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;

  .th-cell:hover {
    [data-sorted] {
      ${Icon}[kind="sorting"] {
        display: block;
      }
      ${Icon}:not([kind^="sorting"]) {
        display: none;
      }
    }
  }
`;

export const TableHeightDrag = styled.div<{ disabled?: boolean }>`
  cursor: grab;
  align-self: center;
  padding: 0.25rem 0.5rem;
  pointer-events: ${({ disabled }) => disabled && "none"};

  &:after {
    content: "";
    display: block;
    width: 2rem;
    height: 0.25rem;
    background-color: ${({ disabled, theme: { palette } }) => !disabled && palette.elementDeep};
    border-radius: ${({ theme: { borderRadius } }) => borderRadius.smallest};
    transition: background-color ${transition.hover};
  }

  &:hover:after {
    background-color: ${({ theme: { palette } }) => palette.iconDisabled};
  }
`;

export const TableContainerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: calc(100% - 2rem);
  padding: 0 1rem 0.3rem;
`;

export const TableTitleAndTools = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWithChip = styled.div`
  position: relative;
`;

export const IconButtonChip = styled(Chip)`
  position: absolute;
  top: -4px;
  left: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.medium};
  padding: 0;
  margin: 0;

  span {
    font-size: 10px;
  }
`;

export const TableContainerTitle = styled.div`
  padding: 0 1rem 0 0.5rem;
`;

export const TableContainerTitleText = styled(H3)`
  margin: 0;
  font-size: 16px;
`;

export const TableContainerControls = styled.div`
  display: flex;
`;

export const DropdownOption = styled.span<{ isVisible?: boolean }>`
  opacity: ${({ isVisible }) => !isVisible && 0.28};
`;

export const DropdownOptionExtraContainer = styled.div`
  display: flex;
`;

export const DropdownOptionExtraIconContainer = styled.div`
  margin: 0 0 0 0.5rem;
`;

export const DeleteFeauturesConfirmContainer = styled.div`
  strong {
    font-weight: 700;
  }
`;

export const HeaderPrefix = styled.span`
  color: ${({ theme }) => theme.palette.textDisabled};
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0;

  ${Icon} {
    color: ${({ theme }) => theme.palette.textDisabled};

    &[kind="sorting"] {
      display: none;
    }
  }
`;

export const TableDropdownContainer = styled(Flex)`
  align-items: center;
`;

export const TempLayerChip = styled(Chip)`
  align-items: center;
  height: 1rem;
  margin-left: 0.5rem;
  padding: 0 0.25rem;
  border-radius: ${({ theme: { borderRadius } }) => borderRadius.tiny};

  > * {
    font-size: 0.625rem;
    line-height: 0;
    color: #fff;
  }
`;
TempLayerChip.defaultProps = {
  primary: true,
  text: "TEMP",
};

export const PlaceholderContainer = styled(Flex)`
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  opacity: 0.28;

  ${Description} {
    color: ${({ theme: { palette } }) => palette.textPrimary};
  }

  ${Icon}::after {
    font-size: 1.5rem;
  }
`;
